import { render, staticRenderFns } from "./Plain.vue?vue&type=template&id=97388230&scoped=true"
import script from "./Plain.vue?vue&type=script&lang=js"
export * from "./Plain.vue?vue&type=script&lang=js"
import style0 from "./Plain.vue?vue&type=style&index=0&id=97388230&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97388230",
  null
  
)

export default component.exports